import React, { createContext, useContext, useMemo } from 'react';
import StaffShift from '@/types/StaffShift';

interface RoomDisplay {
  id: number | string | undefined;
  name: string | undefined;
  staffShifts: StaffShift[];
}

const RoomDisplayContext = createContext<RoomDisplay>({ id: undefined, name: undefined, staffShifts: [] });

interface ProviderProps {
  id: number | string | undefined;
  name: string | undefined;
  staffShifts: StaffShift[];
  children: React.ReactNode;
}

export const RoomDisplayProvider: React.FC<ProviderProps> = ({ id, name, staffShifts, children }) => {
  const value = useMemo(() => ({ id, name, staffShifts }), [id, name, staffShifts]);
  return <RoomDisplayContext.Provider value={value}>{children}</RoomDisplayContext.Provider>;
};

export const useRoomDisplay = (): RoomDisplay => useContext(RoomDisplayContext);
